var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDialog',{attrs:{"eager":true,"max_width":`90%`,"dialog":_vm.dialog,"title":"nuovo cliente"},on:{"close_dialog":_vm.closeDialog}},[_c('ClientEdit',{ref:"client_edit",attrs:{"org_id":_vm.org_id,"is_childcomponent":true,"allowCreateLocation":_vm.allowCreateLocation},on:{"close_dialog":_vm.closeDialog,"add_client":_vm.addClient}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }